import { TooltipProps } from '@mui/material';
import DosenTooltip from '../../../components/ui/DosenTooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type MyTooltipProps = {
    title?: string;
    iconSize?: string;
    iconColor?: string;
    gapleft?: number;
    placement?: TooltipProps['placement'];
};

const MyTooltip: React.FC<MyTooltipProps> = ({ title, iconColor, iconSize, gapleft, placement }) => {
  const tooltipPlacement = placement ? placement : 'bottom';
  const color = iconColor ? iconColor : '#B6B6B6';
  const size = iconSize ? iconSize : '15px';

    return (
    <DosenTooltip tapOnPhone title={title ?? ''} placement={tooltipPlacement}>
            <InfoOutlinedIcon
                sx={{
                    color: color,
                    width: size,
          cursor: 'default',
                    marginLeft: gapleft,
                }}
            />
    </DosenTooltip>
    );
}

export default MyTooltip;

